import { testimonials } from '@/mocks/homeData';

export default function TestimonialsSection() {
  return (
    <section className="w-full bg-secondary-50/50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 mb-4">
            <span className="w-3 h-3 bg-accent-500 rounded-full"></span>
            <span className="text-accent-700 text-xs font-semibold uppercase tracking-wider">瓜友原声</span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950">
            他们都在爆料前线
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {testimonials.slice(0, 3).map((item) => {
            if (item.type === 'photo') {
              return (
                <div key={item.id} className="relative rounded-2xl overflow-hidden aspect-[4/5]">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    title={item.name}
                  />
                  <div className="absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-black/60 to-transparent">
                    <p className="text-background-50 font-semibold text-sm">{item.name}</p>
                    <p className="text-background-50/60 text-xs">{item.role}</p>
                  </div>
                </div>
              );
            }

            return (
              <div key={item.id} className="bg-background-50 rounded-2xl p-5 md:p-6 border border-secondary-200/60">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden flex-shrink-0">
                    <img
                      src={item.avatar}
                      alt={item.name}
                      className="w-full h-full object-cover"
                      title={item.name}
                    />
                  </div>
                  <div>
                    <p className="text-foreground-950 font-semibold text-sm">{item.name}</p>
                    <p className="text-foreground-400 text-xs">{item.role}</p>
                  </div>
                </div>
                <div className="text-accent-500 mb-3">
                  <i className="ri-double-quotes-l text-2xl"></i>
                </div>
                <p className="text-foreground-700 text-sm leading-relaxed">
                  {item.quote}
                </p>
              </div>
            );
          })}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mt-5 md:mt-6">
          {testimonials.slice(3, 6).map((item) => {
            if (item.type === 'photoLarge') {
              return (
                <div key={item.id} className="md:col-span-1 relative rounded-2xl overflow-hidden aspect-[16/9] md:aspect-auto">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    title={item.name}
                  />
                  <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6 bg-gradient-to-t from-primary-900/80 to-transparent">
                    <p className="text-background-50 font-semibold text-sm mb-1">{item.name}</p>
                    <p className="text-background-50/60 text-xs mb-2">{item.role}</p>
                    <p className="text-background-50/80 text-xs leading-relaxed line-clamp-3">
                      {item.quote}
                    </p>
                  </div>
                </div>
              );
            }

            return (
              <div key={item.id} className="bg-background-50 rounded-2xl p-5 md:p-6 border border-secondary-200/60 flex flex-col justify-between">
                <div>
                  <div className="text-accent-500 mb-2">
                    <i className="ri-double-quotes-l text-xl"></i>
                  </div>
                  <p className="text-foreground-700 text-xs md:text-sm leading-relaxed mb-4">
                    {item.quote}
                  </p>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full overflow-hidden flex-shrink-0">
                    <img
                      src={item.avatar}
                      alt={item.name}
                      className="w-full h-full object-cover"
                      title={item.name}
                    />
                  </div>
                  <div>
                    <p className="text-foreground-950 font-semibold text-xs">{item.name}</p>
                    <p className="text-foreground-400 text-xs">{item.role}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}